import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getNotificationSettings,
  updateNotificationSettings,
} from '../services/notificationSettings';
import { toast } from 'react-hot-toast';

export const useNotificationSettings = () => {
  const queryClient = useQueryClient();

  const settingsQuery = useQuery({
    queryKey: ['notificationSettings'],
    queryFn: async () => {
      const response = await getNotificationSettings();
      return response.settings;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  const updateSettingsMutation = useMutation({
    mutationFn: updateNotificationSettings,
    onSuccess: (response) => {
      queryClient.setQueryData(['notificationSettings'], response.settings);
    },
    onError: (error: any) => {
      console.error('Failed to update notification settings', error);
      toast.error('Chyba při ukládání nastavení notifikací');
    },
  });

  return {
    settings: settingsQuery.data,
    isLoading: settingsQuery.isLoading,
    error: settingsQuery.error,
    updateSettings: updateSettingsMutation.mutate,
    isUpdating: updateSettingsMutation.isPending,
  };
};
